import { arrayOf, oneOf, string, number } from 'prop-types';
import { shape, and, or } from 'airbnb-prop-types';

import { SHOP_EVENT_AVAILABILITY_LABEL } from '@common/constants/shopEvent';
import { OFFER_TYPES } from '@common/constants/filters';

export const productCategoryShape = shape({
  id: string,
  slug: string,
  title: string,
});

export const productSizeShape = shape({
  title: string,
  articleNr: string,
  itemNr: string,
  availability: number,
});

export const productBaseColorVariationShape = shape({
  productColorId: string,
  colorTitle: string,
  slug: string,
  price: number,
  specialPrice: number,
  offerType: oneOf(Object.values(OFFER_TYPES)),
  availability: number,
  sortingDate: string,
  sortingPrice: number,
  publishedUntil: string,
  images: arrayOf(string),
  sizes: arrayOf(productSizeShape),
});

export const productBaseShape = shape({
  productId: string,
  title: string,
  description: string,
  material: string,
  washingInstructions: string,
  vendorProductId: string,
  categories: arrayOf(productCategoryShape),
});

// DEFAULT type

export const productDefaultColorVariationShape = and([
  productBaseColorVariationShape,
  shape({
    vendorProductColorId: string,
  }),
]);

export const productDefaultShape = and([
  productBaseShape,
  shape({
    relatedProductColorIds: arrayOf(string),
    colorVariations: arrayOf(productDefaultColorVariationShape),
  }),
]);

// MOMENT type

export const productMomentColorVariationShape = and([
  productBaseColorVariationShape,
  shape({
    productId: string,
    title: string,
    colorhex: string,
    image: string,
    discountPercentage: number,
    availabilityLabel: oneOf([
      ...Object.values(SHOP_EVENT_AVAILABILITY_LABEL),
      null,
    ]),
  }),
]);

export const productMomentShape = and([
  productBaseShape,
  shape({
    relatedProductIds: arrayOf(string),
    colorVariations: arrayOf(productMomentColorVariationShape),
  }),
]);

// ALL types

export const productAllTypesColorVariationShape = or([
  productDefaultColorVariationShape,
  productMomentColorVariationShape,
]);

export const productAllTypesShape = or([
  productDefaultShape,
  productMomentShape,
]);
